import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import { useIsMobile } from '@stores/AppCommonData';
import Divider from '@base/Divider/Divider';
import { segment } from '@actions/analytics';
import { CHECKOUT_STARTED } from '@constants/segment';
import useGoalEventProps from '@hooks/useGoalEventProps';
import { useRouter } from 'next/router';
import { getPlanAvailability } from './NewSubscriptionBenefits/utils';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${Spacings.SPACING_4B};
  margin: ${Spacings.SPACING_12B} auto 0;
  position: relative;
  width: var(--layout-width);
  ${mediaQuery.uptoTablet} {
    width: 100%;
    padding: 0 ${Spacings.SPACING_8B};
  }
  ${mediaQuery.uptoMobile} {
    align-items: flex-start;
    gap: ${Spacings.SPACING_3B};
    margin: ${Spacings.SPACING_5B} auto 0;
    width: 100%;
    padding: 0 ${Spacings.SPACING_4B};
  }
`;

const Header = styled.div`
  margin-bottom: 12px;
  width: 60%;

  ${mediaQuery.uptoTablet} {
    width: 90%;
  }
`;

const BlockTitle = styled(Typography)`
  margin-top: ${Spacings.SPACING_8B};

  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_3B};
  }
`;

const StyledDivider = styled(Divider)`
  width: var(--layout-width);
  margin: auto;
  margin-top: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoTablet} {
    width: 100%;
  }
  ${mediaQuery.uptoMobile} {
    width: 100%;
    /* padding: 0 ${Spacings.SPACING_4B}; */
    box-sizing: border-box;
  }
`;

const data = {
  title: 'Get subscription & start your IIT JEE preparation today',
  subTitle: 'Over 8,00,000 learners trust us for their preparation'
};
const regexNumber = /\d+(,\d+)*/;

const TopHeader = (props) => {
  const isMobile = useIsMobile();
  const { query: { goalUID = '' } = {} } = useRouter();

  const { data: cardData, subscriptionOffers } = props;
  const {
    isIconicAvailable,
    isIconicProAvailable,
    isPlusAvailable,
    isLiteAvailable
  } = getPlanAvailability(cardData, subscriptionOffers);
  let subscriptionsAvailable = 0;
  if (isIconicAvailable) subscriptionsAvailable += 1;
  if (isIconicProAvailable) subscriptionsAvailable += 1;
  if (isPlusAvailable) subscriptionsAvailable += 1;
  if (isLiteAvailable) subscriptionsAvailable += 1;

  const goalSegmentData = useGoalEventProps({ goalUID });

  useEffect(() => {
    segment.track(CHECKOUT_STARTED, {
      ...goalSegmentData
    });
  }, [goalSegmentData]);

  const getHeader = () => {
    return (
      <Header>
        <Typography variant={isMobile ? 'h2' : 'h1'}>
          Get subscription & start your {cardData.name} preparation today
        </Typography>
      </Header>
    );
  };
  const getSubHeader = () => {
    const subHeader = data.subTitle;
    const startIndex = subHeader.search(regexNumber);
    const matchedString = subHeader.match(regexNumber)[0];
    const endIndex = startIndex + matchedString.length + 1;

    return (
      <Typography variant="h5">
        {subHeader.substring(0, startIndex)}{' '}
        <Typography as="span" variant="h5" color="#08BD80">
          {matchedString}
        </Typography>{' '}
        {subHeader.substring(endIndex)}
      </Typography>
    );
  };

  return (
    <Container>
      {getHeader()}
      {getSubHeader()}
      <StyledDivider />
      {subscriptionsAvailable > 1 && (
        <BlockTitle variant={isMobile ? 'h3' : 'h2'}>
          Subscription plans
        </BlockTitle>
      )}
    </Container>
  );
};
export default TopHeader;
